// react core
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import AuthorLink from 'components/commons/author_link';
import { NotificationManager } from 'react-notifications'

// utils
import { clone_object } from 'commons/utils';

// confs
import conf from 'conf/ajax';

export default function VoteButtonsWithState({ id, type, can_vote })
{
    const [fu, set_fu] = useState(0);
    const default_state =
    {
        'voted_up': 0,
        'voted_down': 0,
        'votes_up': 0,
        'votes_down': 0,
        'score': 0,
        'voted_up_by': [],
        'voted_down_by': []
    }
    let params = useParams();

    const vote_url_builder = (type, id, method, params_id) =>
    {
        if(!id || !params_id) return null;
        return (type === 'question') ?
            `${conf.endpoints.qa}${id}/@${method}`
            : `${conf.endpoints.qa}${params_id}/${id}/@${method}`;
    };

    // preparing urls
    const vote_up_url = vote_url_builder(type, id, 'vote-up', params.id);
    const vote_down_url = vote_url_builder(type, id, 'vote-down', params.id);
    const vote_info_url = vote_url_builder(type, id, 'vote-info', params.id);

    const [state, set_state] = useState(default_state);

    // voting up

    // loading data on params
    useEffect(() =>
    {
        if(vote_info_url === null) return;
        let mounted = true;
        const fetchData = async () =>
        {
            const response = await fetch(vote_info_url, conf.ajax_configuration_object);
            const data = await response.json();
            if (mounted)
            {
                set_state(data);
            }
        }
        // call the function
        fetchData()
        // make sure to catch any error
        .catch(console.error);
        return () => mounted = false; // cleanup function
    }, [vote_info_url, fu]);

    const ajax_call = async (uri) =>
    {
        if(uri === null) return;
        let data_obj = clone_object(conf.ajax_configuration_object);
        data_obj.method = 'POST';
        const response = await fetch(uri, data_obj);
        const data = await response.json();
        if(data.status === 'ok')
        {
            // forcing state update
            let tmp = fu + 1;
            set_fu(tmp);
        }
    };

    const vote_up = () =>
    {
        if(can_vote) ajax_call(vote_up_url).then(function(data)
        {
            NotificationManager.info('Your vote has been registered');
        });
        else
        {
            NotificationManager.error('you cannot vote');
        }
    };

    const vote_down = () =>
    {
        if(can_vote) ajax_call(vote_down_url).then(function(data)
        {
            NotificationManager.info('Your vote has been registered');
        });
        else
        {
            NotificationManager.error('you cannot vote');
        }
    };

    const votes_tooltip = (data) =>
    {
        if (data && data.length > 0) {
            return(
                <>
                {data.map(author => (
                    // <span>{author.fullname}</span>
                    <AuthorLink key={author.id} author={author} />
                ))}
                </>
            )
        } else {
            return (
                <>Noboby</>
            )
        }
    };

    let vote_up_classess, vote_down_classess;
    if(can_vote)
    {
        vote_up_classess = 'vote-buttons-up' + ((state.voted_up > 0) ? ' vote-buttons-voted' : '') + ((state.voted_down > 0) ? ' vote-buttons-disabled' : '');
        vote_down_classess = 'vote-buttons-down' + ((state.voted_down > 0) ? ' vote-buttons-voted' : '') + ((state.voted_up > 0) ? ' vote-buttons-disabled' : '');
    }
    else
    {
        vote_up_classess = 'vote-buttons-up vote-buttons-disabled';
        vote_down_classess = 'vote-buttons-down vote-buttons-disabled'; 
    }
    return (
        <>
        <div className="vote-buttons">
            <div onClick={vote_up} className={vote_up_classess}
                title={(state.voted_up === false) ? 'Upvote if you think that is pertinet' : 'Remove your upvote'}>
                <i className="fa-regular fa-thumbs-up"></i>
            </div>
            <div className="vote-buttons-score" title="current score"><span>score</span> <span>{state.score}</span></div>
            <div onClick={vote_down} className={vote_down_classess}
                title={(state.voted_down === false) ? 'Downvote if you think that is NOT pertinet' : 'Remove your downvote'}>
                <i className="fa-regular fa-thumbs-down"></i>
            </div>
        </div>
        <div className="vote-stats">
            {state.votes_up > 0 && <>
            <span data-for={'vote-stats-up-users-' + id} data-tip>{state.votes_up} {state.votes_up === 1 ? `upvote` : `upvotes`}</span>
            <ReactTooltip id={'vote-stats-up-users-' + id}
                getContent={() => {return votes_tooltip(state.voted_up_by)}}
                effect='solid'
                delayHide={500}
                delayShow={500}
                delayUpdate={500}
                place={'right'}
                border={true}
                type={'light'}
                offset={{'left': '20'}}
            />
            </>}
            {state.votes_down > 0 && <>
            <span data-for={'vote-stats-down-users-' + id} data-tip>{state.votes_down} {state.votes_down === 1 ? `downvote` : `downvotes`}</span>
            <ReactTooltip id={'vote-stats-down-users-' + id}
                getContent={() => {return votes_tooltip(state.voted_down_by)}}
                effect='solid'
                delayHide={500}
                delayShow={500}
                delayUpdate={500}
                place={'right'}
                border={true}
                type={'light'}
                offset={{'left': '20'}}
            />
            </>}

        </div>
        </>
    );
};

